import {
  createInternalComponent,
  useTranslation,
  useUrlParam,
} from "@opendash/core";
import { useNavigate } from "@opendash/router";
import * as React from "react";
import {
  DashboardDisplay,
  DashboardLayout,
  useDashboardCurrent,
  useDashboardsBySource,
  useMonitoringService,
} from "..";

interface Props {}

export const DashboardRoute = createInternalComponent<Props>(
  function DashboardRoute({}) {
    const t = useTranslation();
    const MonitoringService = useMonitoringService();

    const dashboards = useDashboardsBySource();
    const [dashboard, setDashboard] = useDashboardCurrent();

    const [, setCreate] = useUrlParam("db_create", false);
    const navigate = useNavigate();
    // Create a new dashboard, if there is none
    React.useEffect(() => {
      createInitialDashboard();
    }, []);

    React.useEffect(() => {
      if (!dashboard) {
        if (dashboards.length === 0) {
          if (!MonitoringService.getConfig().autoCreateInitialDashboard) {
            setCreate(true);
          }
        } else {
          setDashboard(dashboards[0]);
        }
      }
    }, [dashboards]);

    const createInitialDashboard = async () => {
      console.log("call init: ", dashboard);
      if (!dashboard) {
        if (dashboards.length === 0) {
          if (!MonitoringService.getConfig().autoCreateInitialDashboard) {
            setCreate(true);
          } else {
            const autoCreateConfig =
              MonitoringService.getConfig().autoCreateInitialDashboard;

            if (autoCreateConfig) {
              console.log("Creating initial dashboard", dashboards);
              // @ts-ignore
              await MonitoringService.createInitialDashboard({
                name: "Dashboard",
              });
            }
          }
        } else {
          console.log("init set dashboard");
          setDashboard(dashboards[0]);
        }
      }
    };

    return (
      <DashboardLayout>
        <DashboardDisplay dashboard={dashboard} />
      </DashboardLayout>
    );
  }
);
